import { render, staticRenderFns } from "./PleionV1.vue?vue&type=template&id=42c6bf23&scoped=true&"
import script from "./PleionV1.vue?vue&type=script&lang=js&"
export * from "./PleionV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6bf23",
  null
  
)

export default component.exports